// src/components/FloatingWhatsApp.js
import React, { useState, useEffect } from 'react';
import './FloatingWhatsapp/FloatingWhatsapp.css';

const FloatingWhatsApp = () => {
  const [showScrollUp, setShowScrollUp] = useState(false);

  // Show scroll-up button after user scrolls down 300px
  useEffect(() => {
    const onScroll = () => {
      setShowScrollUp(window.pageYOffset > 300);
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <a
        href="https://wa.me/9009279769?text=Hi! I'm interested in your services."
        target="_blank"
        rel="noopener noreferrer"
        className="floating-whatsapp"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
          className="whatsapp-logo"
        />
      </a>

      {showScrollUp && (
        <button
          className="scroll-up-button"
          onClick={scrollToTop}
          title="Scroll to top"
          aria-label="Scroll to top"
        >
          ↑
        </button>
      )}
    </>
  );
};

export default FloatingWhatsApp;
